import { BlockIcon } from '#assets/ReactSvg.ts';
import { Pill } from '#components/atoms/pill/Pill.tsx';

export type AllowListItem =
  | { id: string; cidr: string; allow: boolean }
  | { id: string; interface: string; allow: boolean };

type Props = {
  item: AllowListItem;
};

export function AllowRule({ item }: Props) {
  return (
    <div>
      {'cidr' in item ? item.cidr : `Interface: ${item.interface}`}
      {item.allow ? null : (
        <Pill variant="alert" Icon={BlockIcon} className="ml-8">
          Don’t allow
        </Pill>
      )}
    </div>
  );
}
